import { render, staticRenderFns } from "./InternationalApplyForDeliveryDialog.vue?vue&type=template&id=39690623&scoped=true"
import script from "./InternationalApplyForDeliveryDialog.vue?vue&type=script&lang=js"
export * from "./InternationalApplyForDeliveryDialog.vue?vue&type=script&lang=js"
import style0 from "./InternationalApplyForDeliveryDialog.vue?vue&type=style&index=0&id=39690623&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39690623",
  null
  
)

export default component.exports